'use strict';

export default {
  init() {
    this.finalize();
  },
  finalize() {
    const btnRateCta = document.querySelector('.btn-rate-cta a');
    if (btnRateCta) {
      btnRateCta.addEventListener('click', (e) => {
        e.preventDefault();

        const t = document.querySelector(`.${btnRateCta.dataset.target}`);
        if (t) {
          t.classList.add('open');

          const c = t.querySelector('.close');
          c.addEventListener('click', (e) => {
            e.preventDefault();

            t.classList.remove('open');
          });
        }
      });
    }

  },
};
